<div class="login-container">
    <div class="d-flex justify-content-center">
        <div class="link-device-div col-xl-6 col-lg-6 col-md-12 col-sm-12 row">
            <div class="information col-12 d-flex flex-column justify-content-center">
                <div class="link-device-icon"></div>
                <h4 class="link-device-location">
                    This device needs to be linked.
                </h4>
                <h6 class="create-unique">Contact your administrator.</h6>

                <button (click)="returnToLogin()" class="btn btn-primary btn-block login-button">
                    Return to login page
                </button>
            </div>
        </div>
    </div>
    <div class="logo logo-container"></div>
</div>